import * as React from 'react';
import i18next from 'i18next';
import { LevelItem, LevelRight, LevelLeft, Level } from 'bloomer';
import styled from 'styled-components';

import HeaderDropdown from '../HeaderDropdown/HeaderDropdown';
import { cssVariables } from '../../styles/cssVariables';
import LoggedInAs from '../LoggedInAs/LoggedInAs';
import store from '../../store';
import { defaultLang } from '../../hoc/i18n/i18n';

const getLanguageOptions = () => {
  const result = [];
  if (localStorage.getItem('i18nextLng')) {
    const languages: Record<string, string> = i18next.t(`header.language`, { returnObjects: true });
    for (const lang in languages) {
      if (languages[lang]) {
        result.push({ title: languages[lang], value: lang });
      }
    }
  } else {
    const lang = defaultLang();
    if (lang) {
      localStorage.setItem('i18nextLng', lang);
      getLanguageOptions();
    }
  }
  return result;
};

const changeLanguage = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, selectedLang: string) => {
  return i18next.changeLanguage(selectedLang);
};

const HeaderBar = () => {
  const [pageTitle, setPageTitle] = React.useState('');
  const [email, setEmail] = React.useState('');
  store.subscribe(() => {
    const storeData = store.getState();
    if (storeData && storeData.siteConfig) {
      setPageTitle(storeData.siteConfig.pageTitle);
    }
    setEmail(storeData.user.email);
  });
  return (
    <HeaderContainer>
      <Level>
        <LevelLeft>
          <LevelItem>
            <PageTitle>{pageTitle}</PageTitle>
          </LevelItem>
        </LevelLeft>
        <LevelRight>
          <LevelItem>
            <LoggedInAs email={email} />
            <HeaderDropdown
              selected={i18next.language}
              options={getLanguageOptions()}
              callback={(e, selected) => changeLanguage(e, selected)}
            />
          </LevelItem>
        </LevelRight>
      </Level>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.div`
    padding-top: 0em;
    padding-right: 2em;

    @media screen and (max-width: ${cssVariables.mobileBreakpoint}) {
        padding-right: 0;
    }
`;

const PageTitle = styled.h1`
  font-weight: bold;
  font-size: 1.5rem;
  line-height: 4rem;
  text-transform: capitalize;
  margin-left:1.5em;
`;

export default HeaderBar;